module.exports = __webpack_public_path__ + "e0de445ea6375dd246ea8e0323005952.svg";